import React from "react";
import StatsSection from "../../Components/Portfolio/StatsSection";
import { useNavigate } from "react-router-dom";

const portfolioItems = [
  {
    id: 1,
    img: "https://www.mevabite.com/cdn/shop/articles/almendro01.jpg?v=1718274411&width=1100",
    title: "California Almond Orchards",
    description:
      "Premium almond farms in California delivering high global demand and long-term returns.",
  },
  {
    id: 2,
    img: "https://assets.farmjournal.com/dims4/default/1252b0e/2147483647/strip/true/crop/840x561+0+20/resize/800x534!/quality/90/?url=https%3A%2F%2Ffj-corp-pub.s3.us-east-2.amazonaws.com%2Fs3fs-public%2F2023-03%2FCalifornia-avocado-Oppy-Eco-Farms.png",
    title: "Organic Avocado Farm",
    description:
      "Sustainably grown avocados with rising market value and export potential.",
  },
  {
    id: 3,
    img: "https://blogs.worldbank.org/content/dam/sites/blogs/img/detail/mgr/forests-jen-watson-shutterstock_1213001860-1000.jpg",
    title: "Sustainable Timber Plantation",
    description:
      "Eco-friendly timber investments ensuring renewable resources and stable yields.",
  },
  {
    id: 4,
    img: "https://static.wixstatic.com/media/927754_b7e1de3661cb41fb99c541d8df3cc069~mv2.jpg/v1/fill/w_1068,h_591,al_c/927754_b7e1de3661cb41fb99c541d8df3cc069~mv2.jpg",
    title: "Modern Greenhouse Farming",
    description:
      "High-tech greenhouse farms maximizing crop yield and year-round profitability.",
  },
];

const Portfolio = () => {
const navigate = useNavigate();

  return (
    <section className="px-4 sm:px-6 lg:px-12 py-12 bg-light font-sans text-primaryBgColor tracking-wide">
      {/* Heading */}
      <section className="text-center lg:text-left">
        <h2
          style={{ lineHeight: "1.2" }}
          className="w-full md:w-1/2 text-3xl sm:text-4xl md:text-6xl font-semibold mb-12 text-primaryTextColor"
        >
          Empowering you to Achieve the Impossible .
        </h2>
      </section>

      {/* Portfolio Grid */}
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              onClick={()=>navigate(`/portfolio-details/${item?.id}`)}
              className="cursor-pointer relative group overflow-hidden rounded-2xl shadow-2xl transform transition-all duration-500 hover:scale-[1.02] hover:shadow-3xl"
            >
              {/* Image with gradient overlay */}
              <div className="relative overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-80 md:h-[550px] object-cover transition-all duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>
              </div>

              {/* ✅ Always visible title at bottom-left */}
              <div className="font-mokoto absolute bottom-4 left-4 text-white text-lg font-semibold bg-black/50 px-3 py-1 rounded-lg transition-opacity duration-500 group-hover:opacity-0">
                {item.title}
              </div>

              {/* Hover overlay content */}
              <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
                <h3 className="text-2xl font-bold mb-2 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-300 mb-4 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-200">
                  {item.category || "Project Category"}
                </p>

                {/* Hidden details that appear on hover */}
                <div className="transform translate-y-8 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-300">
                  <p className="text-sm mb-4 line-clamp-2">
                    {item.description ||
                      "Project description goes here. This provides more context about the work."}
                  </p>
                  <div className="flex space-x-3">
                    <button className="px-4 py-2 bg-white text-black text-xs font-semibold rounded-full hover:bg-gray-100 transition-colors">
                      View Project
                    </button>
                    <button className="p-2 border border-white/30 rounded-full hover:bg-white/10 transition-colors">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div className="absolute top-4 right-4 bg-black/80 text-white text-xs font-medium px-3 py-1 rounded-full backdrop-blur-sm">
                {item.year || "2023"}
              </div>

              <div className="absolute inset-0 -inset-x-32 -inset-y-20 bg-gradient-to-r from-transparent via-white/10 to-transparent -rotate-45 group-hover:translate-x-[500px] transition-transform duration-1000"></div>
            </div>
          ))}
        </div>
      </div>

      <StatsSection />

    </section>
  );
};

export default Portfolio;